// extracted by mini-css-extract-plugin
export default {"formWrapper":"LeadFunnelsBulkChangeStateModal_formWrapper__Xma0o"};